import { render, staticRenderFns } from "./AssignmentSharingTable.vue?vue&type=template&id=b6c3f926&scoped=true&"
import script from "./AssignmentSharingTable.vue?vue&type=script&lang=js&"
export * from "./AssignmentSharingTable.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSharingTable.vue?vue&type=style&index=0&id=b6c3f926&scoped=true&lang=css&"
import style1 from "./AssignmentSharingTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c3f926",
  null
  
)

export default component.exports